import { ApiSimpleComponent } from "@incendium/api";
import { Box } from "@mui/material";
import { useMemo } from "react";
import IframeResizer from "iframe-resizer-react";
import { generateThemeStyles } from "../utils";

interface ILanderPreviewProps {
    component: ApiSimpleComponent;
    width?: string | number;
    height?: string | number;
    autoResize?: boolean;
}

function LanderPreview({
    component,
    width = "100%",
    height = "100%",
    autoResize = true
}: ILanderPreviewProps) {
    const htmlContent = useMemo(() => {
        if (!component) return "";

        const theme = component.theme ? JSON.parse(component.theme) : {};
        const themeStyles = generateThemeStyles(theme);


        return `
            <!DOCTYPE html>
            <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    ${component.head || ''}
                    <style>
                        ${themeStyles}
                    </style>
                    <style>
                        ${component.css || ''}
                    </style>
                </head>
                <body style="margin: 0; padding: 0;">
                    ${component.html || ''}
                    ${component.js ? `<script>${component.js}</script>` : ''}
                </body>
            </html>
        `;
    }, [component]);

    if (!autoResize) {
        return (
            <Box
                component="iframe"
                sx={{
                    width,
                    height,
                    border: 'none',
                    backgroundColor: 'white'
                }}
                srcDoc={htmlContent}
                title="Template Preview"
            />
        );
    }

    return (
        <IframeResizer
            srcDoc={htmlContent}
            style={{
                width: width,
                minHeight: height,
                border: 'none',
                backgroundColor: 'white'
            }}
            heightCalculationMethod="lowestElement"
            inPageLinks
            scrolling
            title="Template Preview"
        />
    );
}

export default LanderPreview;
